"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Jul 18 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var GlobalSettingsConverter_1 = require("./conversions/GlobalSettingsConverter");

var GlobalSettingsConverterImpl_1 = require("./conversions/GlobalSettingsConverterImpl");
/**
 * GlobalSettingsAppModule
 *
 * @author RV
 */


var GlobalSettingsAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(GlobalSettingsAppModule, _AppModule_1$AppModul);

  function GlobalSettingsAppModule() {
    var _this;

    _classCallCheck(this, GlobalSettingsAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GlobalSettingsAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'globalSettingsAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(GlobalSettingsAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(GlobalSettingsConverter_1.GlobalSettingsConverter).to(GlobalSettingsConverterImpl_1.GlobalSettingsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return GlobalSettingsAppModule;
}(AppModule_1.AppModule);

exports.GlobalSettingsAppModule = GlobalSettingsAppModule;